import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './globals.css'
import './generalPurposeClasses.css'
import './components/InstagramFeed.css'
import './components/Survey/survey.css'
import App from './App';
import { DocumentsContextProvider } from './context/DocumentContext'
import { AuthContextProvider } from './context/AuthContext'
import {StateContext} from './context/StateContext';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './utils/queryClient';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import ErrorPage from './pages/ErrorPage';
import localforage from 'localforage';

const root = ReactDOM.createRoot(document.getElementById('root'));
//localforage.clear()
root.render(
  <ErrorBoundary
  FallbackComponent={ErrorPage}
  onReset={() => {
    // Reset the state of your app here
    window.location.reload();
  }}
  onError={(error, errorInfo) => {
    // Always log errors to console for debugging
     console.error('Error:', error);
     console.error('Error Info:', errorInfo);
    // Let other errors propagate to the ErrorFallback component
  }}
>
     <AuthContextProvider>
      <StateContext>
        <QueryClientProvider client={queryClient}>
          <DocumentsContextProvider>
            <App />
            <ReactQueryDevtools />
          </DocumentsContextProvider>
        </QueryClientProvider>
      </StateContext>
    </AuthContextProvider>
</ErrorBoundary>
);
{/* <React.StrictMode>  </React.StrictMode> */}